import { IconMissing } from '../../../../../../../assets/icons';
import { AvailableIcon } from '../../../../../../../types';

export const unknownIcons = (): AvailableIcon[] => [
  {
    iconName: '',
    component: <IconMissing />,
  },
];
